import { axiosPost } from 'shared/api/axios'
import { apiUrls } from 'consts'
import displayGenError from 'shared/utils/displayGenError'

interface submitFormProps {
  data: any
  setShowOverlay?: Function
  id: string | undefined
  setIsFormSubmitted: Function
}

const submitForm = async (props: submitFormProps) => {
  props.setIsFormSubmitted(true)
  let response: any = false

  props.data['device_id'] = props.id
  const formData = {
    ...props.data,
  }

  response = await axiosPost(apiUrls.comments, formData, () =>
    displayGenError({
      setShowOverlay: props.setShowOverlay !== undefined ? props.setShowOverlay : () => {},
    }),
  )
  props.setIsFormSubmitted(false)
  return response
}

export default submitForm
